import { render, staticRenderFns } from "./SuperadminTopBoxes.vue?vue&type=template&id=52a91cac&scoped=true&"
import script from "./SuperadminTopBoxes.vue?vue&type=script&lang=js&"
export * from "./SuperadminTopBoxes.vue?vue&type=script&lang=js&"
import style0 from "./SuperadminTopBoxes.vue?vue&type=style&index=0&id=52a91cac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a91cac",
  null
  
)

export default component.exports